export const defaultAlertInfo = {
  open: false,
  severity: "",
  message: "",
}

export const defaultActions = {
  isUpdate: false,
}

export const defaultBandTabs = [
  { label: "2.4 GHz", value: "2", isSelected: true },
  { label: "5 GHz", value: "5", isSelected: false },
  { label: "6 GHz", value: "6", isSelected: false },
];

export const defaultChannelWidths = {
  "2": [
    { value: 1, label: "Mixed 802.11be/ax/n/g/b", isSelected: true },
    { value: 2, label: "Mixed 802.11g/b", isSelected: false },
    { value: 3, label: "802.11n Only", isSelected: false }
  ],
  "5": [
    { value: 4, label: "Mixed 802.11n/a", isSelected: false },
    { value: 5, label: "802.11a Only", isSelected: false },
    { value: 6, label: "802.11n Only", isSelected: false },
    { value: 7, label: "Mixed 802.11be/ax/ac/n/a", isSelected: true }
  ],
  "6": [
    { value: 8, label: "802.11ax Only", isSelected: false },
    { value: 9, label: "Mixed 802.11be/ax", isSelected: true }
  ]
}

export const defaultWirelessModes = {
  "2": [
    { value: 1, label: "20MHz (20MHz)", isSelected: true },
    { value: 2, label: "auto20-40 (Auto 20/40 MHz)", isSelected: false }
  ],
  "5": [
    { value: 1, label: "20MHz (20MHz)", isSelected: true },
    { value: 2, label: "auto20-40 (Auto 20/40 MHz)", isSelected: false },
    { value: 3, label: "auto20-40-80-160 (Auto 20/40/80/160 MHz)", isSelected: false }
  ],
  "6": [
    { value: 1, label: "20MHz (20MHz)", isSelected: true },
    { value: 2, label: "auto20-40 (Auto 20/40 MHz)", isSelected: false },
    { value: 3, label: "auto20-40-80-160 (Auto 20/40/80/160 MHz)", isSelected: false },
    { value: 4, label: "auto20-40-80 (Auto 20/40/80)", isSelected: false },
    { value: 5, label: "auto20-40-80-160-320 (Auto 20/40/80/160/320 MHz)", isSelected: false }
  ]
}

export const defaultUtilizationList = [
  { value: 0, label: "0%", isSelected: true },
  { value: 20, label: "20%", isSelected: false },
  { value: 40, label: "40%", isSelected: false },
  { value: 60, label: "60%", isSelected: false },
  { value: 80, label: "80%", isSelected: false },
  { value: 100, label: "100%", isSelected: false }
];

export const defaultRSSIThresholdList = [
  { value: 10, label: "10%", isSelected: true },
  { value: 20, label: "20%", isSelected: false },
  { value: 30, label: "30%", isSelected: false },
  { value: 40, label: "40%", isSelected: false },
  { value: 50, label: "50%", isSelected: false },
  { value: 60, label: "60%", isSelected: false },
  { value: 70, label: "70%", isSelected: false },
  { value: 80, label: "80%", isSelected: false },
  { value: 90, label: "90%", isSelected: false },
  { value: 100, label: "100%", isSelected: false }
];

export const defaultStartTimeList = Array.from({ length: 48 }, (item, index) => {
  const hr = String(Math.floor(index / 2)).padStart(2, "0");
  const min = index % 2 === 0 ? "00" : "30";
  const value = `${hr}:${min}`;

  return { label: value, value, isSelected: false };
});
